import { htmlParserOptions } from 'utils/constants';

export const getTicketsV2Translations = (intl) => ({
  Common: {
    details: intl.formatMessage({
      description: 'V2 Buy details',
      defaultMessage: 'Details',
    }),
    proceedMsg: intl.formatMessage({
      description: 'V2 Buy proceedMsg',
      defaultMessage: 'Proceed',
    }),
    assignTicket: intl.formatMessage({
      description: 'V2 Assign assignMessage',
      defaultMessage: 'Name ticket-holders',
    }),
    ofText: intl.formatMessage({
      description: 'V2 OF text',
      defaultMessage: 'of',
    }),
    tickets: intl.formatMessage({
      description: 'V2 tickets',
      defaultMessage: 'Tickets',
    }),
    discountApply: intl.formatMessage({
      description: 'V2 tickets discountApply',
      defaultMessage: 'Promo code correctly applied',
    }),
    faqTitle: intl.formatMessage({
      description: 'V2 Common FAQ title',
      defaultMessage: 'Do you have any doubts or questions?',
    }),
    article: intl.formatMessage({
      description: 'V2 Common item',
      defaultMessage: 'item',
    }),
    articles: intl.formatMessage({
      description: 'V2 Common items',
      defaultMessage: 'items',
    }),
    operator: intl.formatMessage({
      description: 'V2 Common operator',
      defaultMessage: 'Trade Visitor',
    }),
    prdTicketLabel: intl.formatMessage({
      description: 'V2 Common prdTicketLabel',
      defaultMessage: 'Supplier/Manufacturer',
    }),
    generalPublic: intl.formatMessage({
      description: 'V2 Common generalPublic',
      defaultMessage: 'General public',
    }),
    backBtn: intl.formatMessage({
      description: 'V2 Common backBtn',
      defaultMessage: 'Back',
    }),
    delete: intl.formatMessage({
      description: 'V2 Common delete',
      defaultMessage: 'Delete',
    }),
    edit: intl.formatMessage({
      description: 'V2 Common edit',
      defaultMessage: 'Edit data',
    }),
    editRecap: intl.formatMessage({
      description: 'V2 Common editRecap',
      defaultMessage: 'Edit data',
    }),
    editQuantity: intl.formatMessage({
      description: 'V2 Common editQuantity',
      defaultMessage: 'Edit quantity',
    }),
    updateQuantity: intl.formatMessage({
      description: 'V2 Common updateQuantity',
      defaultMessage: 'Update quantity',
    }),
    accountOwner: intl.formatMessage({
      description: 'V2 Common accountOwner',
      defaultMessage: 'Account owner',
    }),
    backToRecap: intl.formatMessage({
      description: 'V2 Common backToRecap',
      defaultMessage: 'Back to recap',
    }),
    novelty: intl.formatMessage({
      description: 'V2 Common novelty',
      defaultMessage: 'New',
    }),
    product: intl.formatMessage({
      description: 'V2 Common product',
      defaultMessage: 'Product',
    }),
    price: intl.formatMessage({
      description: 'V2 Common price',
      defaultMessage: 'Price',
    }),
    quantity: intl.formatMessage({
      description: 'V2 Common quantity',
      defaultMessage: 'Quantity',
    }),
    downloadAll: intl.formatMessage({
      description: 'V2 Common downloadAll',
      defaultMessage: 'Download',
    }),
    download: {
      ticket: intl.formatMessage({
        description: 'V2 Common download ticket',
        defaultMessage: 'Download Ticket',
      }),
      merch: intl.formatMessage({
        description: 'V2 Common download merch',
        defaultMessage: 'Receipt for catalog collection',
      }),
    },
    editDate: intl.formatMessage({
      description: 'V2 Common editDate',
      defaultMessage: 'Edit dates',
    }),
    save: intl.formatMessage({
      description: 'V2 Common save',
      defaultMessage: 'Save',
    }),
    caution: intl.formatMessage({
      description: 'V2 Common caution',
      defaultMessage: 'Caution: mandatory fields required',
    }),
    yes: intl.formatMessage({
      description: 'V2 Common yes',
      defaultMessage: 'Yes',
    }),
    no: intl.formatMessage({
      description: 'V2 Common no',
      defaultMessage: 'No',
    }),
  },
  Buy: {
    greetings1: intl.formatMessage({
      description: 'V2 Buy greetings1',
      defaultMessage: 'Hi',
    }),
    greetings2: intl.formatMessage({
      description: 'V2 Buy greetings2',
      defaultMessage: 'How many tickets do you need?',
    }),
    numberOfTickets: intl.formatMessage({
      description: 'V2 Buy numberOfTickets',
      defaultMessage: 'A maximum of 15 tickets can be purchased.',
    }),
    cartTicket: intl.formatMessage({
      description: 'V2 Buy cartTicket',
      defaultMessage: 'Salone del Mobile Ticket',
    }),
    cartMerch: intl.formatMessage({
      description: 'V2 Buy cartMerch',
      defaultMessage: 'Catalogue Salone',
    }),
    operatorFaqItem: {
      title: intl.formatMessage({
        description: 'V2 Buy operatorFaqItem title',
        defaultMessage: 'How the Season Ticket works',
      }),
      body: intl.formatMessage({
        description: 'V2 Buy operatorFaqItem body',
        defaultMessage:
          'The Season Ticket enables you to visit the Salone del Mobile.Milano every day. You will be asked to indicate the days (1 to 6) on which you wish to make your visit. You can change the date at any time in your reserved area.',
      }),
    },
    GenevaFaqItem: {
      title: intl.formatMessage({
        description: 'V2 Buy operatorFaqItem title',
        defaultMessage: 'How do I get a Watches and Wonders 2025 promo code?',
      }),
      body: intl.formatMessage({
        description: 'V2 Buy operatorFaqItem body',
        defaultMessage:
          'When purchasing a one-day ticket for the ‘Watches and Wonders Geneva 2025’ fair at www.watchesandwonders.com you will receive a promo code valid to purchase a Season Trade Visitor Ticket at a reduced price. If the code entered is incorrect or has already been used, it will be invalid.',
      }),
    },
    faqList: [
      {
        title: intl.formatMessage({
          description: 'V2 Buy FAQ1 title',
          defaultMessage: 'Are you traveling with a minor?',
        }),
        body: intl.formatMessage({
          description: 'V2 Buy FAQ1 body',
          defaultMessage:
            'The Salone del Mobile.Milano is a trade event and children under the age of 10 are not permitted to enter. Children from the age of 14 fall into the “student” category and can visit the Salone on Friday, Saturday and Sunday. For children under the age of 14, on days open to the public, it is necessary to contact the reception See the “Visit Information” page for full details.',
        }),
      },
      {
        title: intl.formatMessage({
          description: 'V2 Buy FAQ2 title',
          defaultMessage:
            'Do you want to buy tickets for persons with disabilities?',
        }),
        body: intl.formatMessage({
          description: 'V2 Buy FAQ2 body',
          defaultMessage:
            'Persons with disabilities, on presenting their disabled pass or the FierAccessible card at the reception desks, will receive a complimentary entrance ticket. If the person needs to be accompanied on the visit, free admission will be extended to the carer. Find more information for visiting on the Accessibility page',
        }),
      },
      {
        title: intl.formatMessage({
          description: 'V2 Buy FAQ3 title',
          defaultMessage: 'Do you need a tax document?',
        }),
        body: intl.formatMessage({
          description: 'V2 Buy FAQ3 body',
          defaultMessage:
            'Tickets are valid in all respects for tax purposes such as claiming business expenses (Art.74 quater, c.2 of Presidential Decree 633/1972), being certification of the ticket price. Hence no further tax document will be issued.',
        }),
      },
      {
        title: intl.formatMessage({
          description: 'V2 Buy FAQ4 title',
          defaultMessage: 'Do you want to buy several tickets?',
        }),
        body: intl.formatMessage({
          description: 'V2 Buy FAQ4 body',
          defaultMessage:
            'The purchase limit for each order is 20 tickets. If you need to buy a larger number, you will have to place another order.',
        }),
      },
    ],
  },
  Merch: {
    title: intl.formatMessage({
      description: 'V2 Merch Title',
      defaultMessage: 'Do you want to buy the catalogue of the Salone?',
    }),
    titleSubtext: intl.formatMessage({
      description: 'V2 Merch Title Subtext',
      defaultMessage:
        'You can buy it now and avoid the queue. You will need  to pick it up in person directly at the Salone. You will receive  your pickup voucher via email.',
    }),
    faqList: [
      {
        title: intl.formatMessage({
          description: 'V2 Merch FAQ1 title',
          defaultMessage: 'How can I get the catalogue I have purchased?',
        }),
        body: intl.formatMessage({
          description: 'V2 Merch FAQ1 body',
          defaultMessage:
            'The catalogue has to be collected at the trade fair during the event. It will not be posted. Download the coupon for collection from the order summary in the reserved area.',
        }),
      },
      {
        title: intl.formatMessage({
          description: 'V2 Merch FAQ2 title',
          defaultMessage: 'Do you need a tax document?',
        }),
        body: intl.formatMessage({
          description: 'V2 Merch FAQ2 body',
          defaultMessage:
            'In relation to the sale of catalogues, there is no obligation to issue an invoice since the tax is paid by the publisher (Article 74 paragraph 1 letter c) of Presidential Decree 633/72). We recommend that you keep the order confirmation and the payment receipt received by email for any administrative requirements.',
        }),
      },
    ],
  },
  Assign: {
    title: intl.formatMessage({
      description: 'V2 AssignTicket Title',
      defaultMessage: 'Name ticket-holders',
    }),
    titleSubtext: intl.formatMessage({
      description: 'V2 AssignTicket Title Subtext',
      defaultMessage:
        'Name the ticket-holders and choose the dates on which to visit the Salone del Mobile.Milano. If necessary, after completing the purchase you can change the  visit dates in your reserved area.',
    }),
    ticket: intl.formatMessage({
      description: 'V2 AssignTicket ticket index',
      defaultMessage: 'Ticket',
    }),
    ticketHolderFormTitle: intl.formatMessage({
      description: 'V2 AssignTicket ticket holder form title',
      defaultMessage: 'Data of ticket-holder',
    }),
    ticketHolderFormSubtitle: intl.formatMessage({
      description: 'V2 AssignTicket ticket holder form subtitle',
      defaultMessage: 'Use your details for this ticket',
    }),
    datesTitle: intl.formatMessage({
      description: 'V2 AssignTicket dates title',
      defaultMessage: 'Dates',
    }),
    operatorDatesTitle: intl.formatMessage({
      description: 'V2 AssignTicket dates operatorDatesTitle',
      defaultMessage: 'Visit dates',
    }),
    datesSubtitle: intl.formatMessage({
      description: 'V2 AssignTicket dates subtitle',
      defaultMessage:
        'Choose the days on which to visit the Salone del Mobile.Milano. You can change this choice later in the order summary section of your Reserved area',
    }),
    singleDateSubtitle: intl.formatMessage({
      description: 'V2 AssignTicket single date subtitle',
      defaultMessage:
        'Choose the day on which to visit the Salone del Mobile.Milano. You can change this choice later in the order summary section of your Reserved area',
    }),
    operatorDatesSubtitle: intl.formatMessage({
      description: 'V2 AssignTicket operatorDatesSubtitle',
      defaultMessage: 'Select the days (1 to',
    }),
    operatorDatesSubtitleDynamic: intl.formatMessage({
      description: 'V2 AssignTicket operatorDatesSubtitleDynamic',
      defaultMessage:
        ') on which you plan to visit the Salone del Mobile.Milano.',
    }),
    operatorDatesSecondSubtitle: intl.formatMessage({
      description: 'V2 AssignTicket operatorDatesSecondSubtitle',
      defaultMessage:
        'If you change your mind, you can always change the dates in the order summary section of your reserved area.',
    }),
    operatorBoxTitle: intl.formatMessage({
      description: 'V2 AssignTicket operatorBoxTitle',
      defaultMessage:
        'Indication of the date is necessary to activate the ticket',
    }),
    operatorBoxSubTitleOne: intl.formatMessage({
      description: 'V2 AssignTicket operatorBoxSubTitleOne',
      defaultMessage:
        'You can change the visit dates when and how many times you want from your MySalone reserved area.',
    }),
    operatorBoxSubTitleTwo: intl.formatMessage({
      description: 'V2 AssignTicket operatorBoxSubTitleTwo',
      defaultMessage:
        'Attention, if you visit the Salone del Mobile.Milano on a day other than those indicated, you will have to contact the helpdesk to gain access.',
    }),
    consentTitle: intl.formatMessage({
      description: 'V2 AssignTicket consentTitle',
      defaultMessage: 'Consent management',
    }),
    flags: {
      privacyOne: intl.formatMessage({
        description: 'V2 AssignTicket flags privacyOne',
        defaultMessage:
          'I confirm that I have read and understood the Privacy Policy – INFORMATIVE PLATFORM pursuant to Article 13 of Regulation (EU) 2016/679 available at the link:',
      }),
      privacyTwo: intl.formatMessage({
        description: 'V2 AssignTicket flags privacyTwo',
        defaultMessage:
          'I consent to the processing of my personal data for the receipt of communications for marketing purposes and for sending communications of an institutional, commercial and promotional nature, including newsletters and invitations to initiatives organized by Federlegno Arredo Eventi S.p.A. (Salone del Mobile.Milano) and/or subsidiaries and/or affiliates, surveys and market research.',
      }),
      privacyThree: intl.formatMessage({
        description: 'V2 AssignTicket flags privacyThree',
        defaultMessage:
          'I consent to the processing of my personal data for the purposes of profiling and analysis of consumer habits by Federlegno Arredo Eventi S.p.A. (Salone del Mobile.Milano) and/or subsidiaries and/or associates.',
      }),
      errors: {
        privacy: intl.formatMessage({
          description: 'V2 AssignTicket errors flags privacy',
          defaultMessage: 'Consent to the privacy policy is mandatory',
        }),
        data: intl.formatMessage({
          description: 'V2 AssignTicket errors flags data',
          defaultMessage:
            'Consent to the processing of personal data is required',
        }),
      },
    },
    errors: {
      operatorOneDate: {
        title: intl.formatMessage({
          description: 'V2 AssignTicket errors operatorOneDate title',
          defaultMessage:
            'You must indicate the dates scheduled for your visit',
        }),
        subtitleOne: intl.formatMessage({
          description: 'V2 AssignTicket errors operatorOneDate subtitle',
          defaultMessage: 'You can change',
        }),
        subtitleLink: intl.formatMessage({
          description: 'V2 AssignTicket errors operatorOneDate subtitle',
          defaultMessage: 'the visit dates',
        }),
        subtitleTwo: intl.formatMessage({
          description: 'V2 AssignTicket errors operatorOneDate subtitle',
          defaultMessage:
            'whenever and as many times as you want from your reserved area.',
        }),
      },
      missingDates: {
        warning: intl.formatMessage({
          description: 'V2 AssignTicket errors missingDates warning',
          defaultMessage: 'Caution: you have not selected',
        }),
        warningOneDay: intl.formatMessage({
          description: 'V2 AssignTicket errors missingDates warningOneDay',
          defaultMessage: 'the date permitted in your ticket',
        }),
        the: intl.formatMessage({
          description: 'V2 AssignTicket errors missingDates the',
          defaultMessage: 'the',
        }),
        all: intl.formatMessage({
          description: 'V2 AssignTicket errors missingDates all',
          defaultMessage: 'all',
        }),
        dates: intl.formatMessage({
          description: 'V2 AssignTicket errors missingDates dates',
          defaultMessage: 'dates permitted in your ticket',
        }),
        before: intl.formatMessage({
          description: 'V2 AssignTicket errors missingDates before',
          defaultMessage: 'Before continuing',
        }),
        selectDates: intl.formatMessage({
          description: 'V2 AssignTicket errors missingDates selectDates',
          defaultMessage: 'select the dates',
        }),
        selectDateOneDay: intl.formatMessage({
          description: 'V2 AssignTicket errors missingDates selectDateOneDay',
          defaultMessage: 'select the date',
        }),
      },
      privacy: {
        title: intl.formatMessage({
          description: 'V2 AssignTicket errors privacy title',
          defaultMessage:
            'Caution: you must read and accept the Privacy Policy',
        }),
        subtitle: intl.formatMessage({
          description: 'V2 AssignTicket errors privacy title',
          defaultMessage: 'read and accept the Privacy Policy',
        }),
      },
      generalPrivacy: {
        descriptionOne: intl.formatMessage({
          description: 'V2 AssignTicket errors generalPrivacy descriptionOne',
          defaultMessage: 'It is necessary to correctly fill in',
        }),
        descriptionLink: intl.formatMessage({
          description: 'V2 AssignTicket errors generalPrivacy descriptionLink',
          defaultMessage: 'all the mandatory fields',
        }),
        descirptionTwo: intl.formatMessage({
          description: 'V2 AssignTicket errors generalPrivacy descriptionLink',
          defaultMessage: 'to proceed with the purchase.',
        }),
      },
      emailAlreadyUsed: {
        title: intl.formatMessage({
          description: 'V2 AssignTicket errors emailAlreadyUsed title',
          defaultMessage:
            'Caution: you have already used this email for another ticket',
        }),
        message: intl.formatMessage({
          description: 'V2 AssignTicket errors emailAlreadyUsed message',
          defaultMessage:
            'If it is not an error, continue, or replace the email address entered for this ticket.',
        }),
      },
      emailNotValid: {
        title: intl.formatMessage({
          description: 'V2 AssignTicket errors emailNotValid title',
          defaultMessage:
            'Caution: this email address seems to be non-existent',
        }),
        subtitle: intl.formatMessage({
          description: 'V2 AssignTicket errors emailAlreadyUsed subtitle',
          defaultMessage: 'Check that you typed correctly',
        }),
        email: intl.formatMessage({
          description: 'V2 AssignTicket errors emailAlreadyUsed email',
          defaultMessage: 'the email address',
        }),
      },
      tooMuchDates: {
        warning: intl.formatMessage({
          description: 'V2 AssignTicket errors tooMuchDates warning',
          defaultMessage: 'Caution: you can only select',
        }),
        date: intl.formatMessage({
          description: 'V2 AssignTicket errors tooMuchDates date',
          defaultMessage: 'date',
        }),
        dates: intl.formatMessage({
          description: 'V2 AssignTicket errors tooMuchDates warning',
          defaultMessage: 'dates',
        }),
        forThis: intl.formatMessage({
          description: 'V2 AssignTicket errors tooMuchDates forThis',
          defaultMessage: 'For this ticket you can',
        }),
        onlySelect: intl.formatMessage({
          description: 'V2 AssignTicket errors tooMuchDates onlySelect',
          defaultMessage: 'only select',
        }),
      },
    },
  },
  Recap: {
    recapTitle: intl.formatMessage({
      description: 'V2 Recap title',
      defaultMessage: 'Order Recap',
    }),
    conditionsOfSale: intl.formatMessage({
      description: 'V2 Recap conditions of sale',
      defaultMessage: 'Conditions of sale',
    }),
    conditionsOfSaleParsedBody: intl.formatMessage(
      {
        description: 'V2 Recap conditionsOfSaleParsedBody',
        defaultMessage:
          "<spaced><strong>Federlegno Arredo Eventi S.p.A. is the organizer of the events named Salone Internazionale del Mobile, International Furnishing Accessories Exhibition, Workplace3.0, S.Project, Euroluce and SaloneSatellite (hereinafter, EVENTS), jointly identified at the national, community and international level with the following registered and protected trademark, of which it is the owner:  Salone del Mobile.Milano.</strong></spaced><spaced><strong>Federlegno Arredo Eventi S.p.A. (hereinafter, ORGANIZER or FLAE) is in charge of the online sales service of admission tickets and general catalogues of the event, using its own ticketing system regulated by the conditions below.</strong></spaced><spaced><strong>REGULATION FOR THE PURCHASE OF GOODS AND SERVICES</strong></spaced><spaced>The following statements regulate the relations between FLAE as provider of the service (hereinafter referred to as the SERVICE) and the user/users of this service (hereinafter referred to as USER/USERS). The USER who takes advantage of the SERVICE is required to comply with all the general conditions contained in this regulation. This regulation must therefore be read and approved in its entirety before completing the purchase.</spaced><spaced>Art. 1 - <strong>OBJECT OF THE SERVICE</strong></spaced><spaced>The SERVICE has as its object the online sale of admission tickets and general catalogues of the event (hereinafter referred to as CATALOGUES) by the ORGANIZER of the EVENTS.</spaced><spaced>Art. 2 - <strong>PAYMENT FOR THE SERVICE</strong></spaced><spaced>Payment for the SERVICE may be made: i) by credit card - Visa, Mastercard, Amex, China Union Pay, JCB, Discover and Diners Club, eftpos Australia, ii) by digital wallet – Google Pay and Apple Pay; (iii) Alipay. Payment is made through a virtual payment system in secure mode with irreversible 128-bit encryption. By this method, the transaction takes place exclusively in the banking sector. FLAE does not have in any way access to the data of the USER's credit card. FLAE therefore has no responsibility for the numbers and credit card data provided to the bank at the time of the online purchase of the admission ticket and catalogues. With reference to the purchase of admission tickets, from the moment of opening of the online sale until 23.59 (CEST) on April 4, 2025, the pre-sale rates indicated on the dedicated web page will be applied; from April 5, 2025 and until the end of the EVENTS, the full rates also indicated on the dedicated web page will apply.<div>Users in possession of a promotional code issued by the Watches and Wonders Geneva event will be able to purchase a Trade Visitor Season Ticket at the discounted price of € 30.00 by entering the code received in the space provided in the shopping cart. The online purchase of the Operator Season Ticket, until 11.59 p.m. CEST on 4 April 2025, will entitle the operator to use a promotional code to purchase a 1-day admission ticket to the Watches and Wonders Geneva event, with a 50% discount on the ‘Normal Rate’, ‘Young’ and ‘Senior’ types.</div><div>According to Article 74 – quater, par. 2 of the Presidential Decree no. 633/1972 tickets are fiscal documents to all intents and purposes, hence they constitute evidence of the ticket’s value. Therefore invoices will not be issued.</div></spaced><spaced>Art. 3 - <strong>OBLIGATIONS OF THE PURCHASER AND THE HOLDER OF THE CREDIT CARD AND DIGITAL WALLET</strong></spaced><spaced>The USER undertakes to view, carefully read and accept the contractual clauses referred to in this regulation, as a necessary condition for purchase, since these are clauses drawn up in accordance with Article 12 of Legislative Decree 70/03 (electronic commerce).</spaced><spaced>The purchase order must be forwarded by the holder of the credit card or digital wallet.</spaced><spaced>Please note that the improper use of a credit card is prosecuted criminally under Article 12 of Legislative Decree May 3, 1991 no. 143, converted with amendments into Law July 5, 1991 no. 197, for transactions performed on the internet by providing the identificatory and operational data of another person’s credit card, acquired fraudulently by the agent.</spaced><spaced><underline>Effectiveness of the agreement and Documentation to be kept.</underline></spaced><spaced>The order and reception of confirmation of the order are considered received when the parties, to whom they are addressed, have the opportunity to access them.</spaced><spaced>Therefore, the USER must carefully keep:</spaced><spaced><div>a) <underline>in the case of the admission tickets</underline>: order confirmation e-mail with the summary of the purchase and the e-mail containing the admission tickets in .pdf format, which are the document necessary for direct access to the EVENTS;</div>b) <underline>in the case of the CATALOGUES</underline>: order confirmation e-mail with the summary of the purchase, e-mail containing the voucher in .pdf format for the receipt of the CATALOGUES at the Rho (MI) exhibition center during the days of the EVENTS and the instructions for the possible download of the voucher itself. </spaced><spaced>It is understood that, with the transmission of the .pdf of the admission tickets and/or the voucher for the receipt of the CATALOGUES and the instructions for downloading the voucher, FLAE will have correctly and accurately fulfilled the obligations acquired, with the effect that the holder of the credit card or digital wallet, used for the online operation is unable to request the bank to refund the sums used for this purpose, under penalty of compensation for damages in favor of FLAE.</spaced><spaced>It should be noted that failure to collect the catalogues at the Rho (MI) exhibition center will not give rise to any refund.</spaced><spaced>Art. 4 - <strong>RIGHTS AND OBLIGATIONS OF FLAE</strong></spaced><spaced>FLAE may suspend the SERVICE in  part or in whole for unforeseeable technical reasons, or for any changes intended to improve the service itself.</spaced><spaced>FLAE is responsible for the CATALOGUES until the confirmation of payment relating to the purchase of the same. The loss and/or mislaying of and/or delay in the delivery of admission tickets and/or vouchers essential for the collection of the CATALOGUES by third parties will represent unforeseeable circumstances on the part of FLAE. Furthermore, FLAE will not be liable for the non-use of admission tickets (even if delivered and/or collected) and/or failure to collect the CATALOGUES by the USER. In such cases, all right to reimbursement of the admission tickets and/or the price of the CATALOGUES by the ORGANIZER is excluded.</spaced><spaced>Art. 5 - <strong>CANCELLATION OF EVENT OR CANCELLATION OF ADMISSION TICKETS</strong></spaced><spaced><underline>With reference to admission tickets</underline>, in the event that one or more EVENTS are canceled, the USER will be entitled to a refund of the relative admission ticket purchased. To this end, the USER must submit a request for reimbursement in writing to be sent to the ORGANIZER: i) by registered letter with return receipt to the address: Foro Buonaparte no. 65, Milan; or ii) by e-mail to the address tickets@salonemilano.it, no later than May 31, 2025. The shipping costs related to the refund request will be borne by the USER. In the event of cancellation of one or more EVENTS, the respective entrance tickets will be canceled in the manner referred to under Article 7 of Ministerial Decree of July 13, 2000. The same cancelation procedures will apply in the case of cancelation of admission tickets due to incorrect issuance of the admission ticket itself. With the exception of the cases specified above, admission tickets cannot be canceled and consequently refunded. The USER will therefore be entitled to a refund of the sums paid for the purchase of the admission ticket, minus the bank charges, incurred by FLAE, provided that he/she has made the relative request in keeping with the above terms and methods. </spaced><spaced>Art. 6 - <strong>RIGHT OF WITHDRAWAL</strong></spaced><spaced><underline>With reference to the CATALOGUES</underline>, the right to exercise the right of withdrawal within 10 days from the time of purchase and in any case no later than the fifth working day before the start of the EVENTS is allowed. Withdrawal is exercised by written request to the ORGANIZER to be sent: i) by registered letter with return receipt to the following address: Milan, Foro Buonaparte no. 65; or ii) by e-mail to the address tickets@salonemilano.it, within the terms indicated above.<div>In this case, the USER will be entitled to a refund of the sums paid for the purchase of the CATALOGUES, minus the bank charges incurred by FLAE, provided that he/she has exercised the right of withdrawal in compliance with the abovementioned methods and times and, in any case, before the EVENTS in which he/she had an interest in participating, while any possible request for withdrawal and/or reimbursement subsequent to the above EVENTS will not be valid.</div></spaced><spaced>Art. 7 - <strong>LIMITATIONS OF LIABILITY</strong></spaced><spaced>FLAE accepts no responsibility for direct or indirect damages in any way connected to the SERVICE. FLAE undertakes to provide the competent authorities without delay with all the information in its possession in order to allow the identification and prevention of any offenses committed on internet.</spaced><spaced>Art. 8 - <strong>ARBITRATION CLAUSE</strong></spaced><spaced>For any dispute, the Court of Milan is established as having exclusive jurisdiction.</spaced><spaced>Art. 9 - <strong>APPLICABLE LEGISLATION</strong></spaced><spaced>If not expressly referred to herein, Italian and EU legislation must be considered applicable.</spaced>",
      },
      { ...htmlParserOptions }
    ),
    secondAccept: intl.formatMessage({
      description: 'V2 Recap secondAccept',
      defaultMessage:
        'Pursuant to and for the purposes of Articles 1341 and 1342 of the Civil Code, the USER expressly declares approval of the following provisions of the REGULATION FOR THE PURCHASE OF GOODS AND SERVICES: Article 1 (OBJECT OF THE SERVICE), Article 2 (PAYMENT FOR THE SERVICE), Article 3 - OBLIGATIONS OF THE PURCHASER AND THE HOLDER OF THE CREDIT CARD AND DIGITAL WALLET; Art. 5 (CANCELLATION OF EVENT OR CANCELLATION OF ADMISSION TICKETS), Art. 6 (RIGHT OF WITHDRAWAL), and Art. 7 (LIMITATIONS OF LIABILITY).',
    }),
    accept: intl.formatMessage({
      description: 'V2 Recap accept',
      defaultMessage: 'Accept',
    }),
    april: intl.formatMessage({
      description: 'V2 Recap april',
      defaultMessage: 'April',
    }),
    day: intl.formatMessage({
      description: 'V2 Recap day',
      defaultMessage: 'day',
    }),
    days: intl.formatMessage({
      description: 'V2 Recap days',
      defaultMessage: 'days',
    }),
    tickets: intl.formatMessage({
      description: 'V2 Recap tickets',
      defaultMessage: 'Ticket',
    }),
    otherPurchases: intl.formatMessage({
      description: 'V2 Recap otherPurchases',
      defaultMessage: 'Other purchases',
    }),
    moreTickets: intl.formatMessage({
      description: 'V2 Recap moreTickets',
      defaultMessage: 'Do you need more tickets?',
    }),
    addCatalogue: intl.formatMessage({
      description: 'V2 Recap addCatalogue',
      defaultMessage: 'Do you want to buy the catalogue?',
    }),
    assignNew: intl.formatMessage({
      description: 'V2 Recap assignNew',
      defaultMessage: 'Assign new tickets',
    }),
    dialogTitle: intl.formatMessage({
      description: 'V2 Recap dialogTitle',
      defaultMessage: 'Add more tickets to cart',
    }),
  },
  Success: {
    title: intl.formatMessage({
      description: 'V2 Success title',
      defaultMessage: 'Purchase successfully completed!',
    }),
    subtitle: intl.formatMessage({
      description: 'V2 Success subtitle',
      defaultMessage:
        'From your reserved area you can manage, download and print your tickets.',
    }),
    backBtn: intl.formatMessage({
      description: 'V2 Success backBtn',
      defaultMessage: 'Go back to home',
    }),
    yourTicketsBtn: intl.formatMessage({
      description: 'V2 Success yourTicketsBtn',
      defaultMessage: 'Your tickets',
    }),
  },
  SuccessWithActions: {
    title: intl.formatMessage({
      description: 'V2 SuccessWithActions title',
      defaultMessage: 'Thank you for your purchase',
    }),
    subtitleGoOne: intl.formatMessage({
      description: 'V2 Success subtitleGoOne',
      defaultMessage:
        'We remind you that it is possible to reach Salone del Mobile.Milano in a sustainable way. All useful information is available on the',
    }),
    subtitleGoLink: intl.formatMessage({
      description: 'V2 Success subtitleGoLink',
      defaultMessage: 'How to get there',
    }),
    subtitleGoPage: intl.formatMessage({
      description: 'V2 Success subtitleGoPage',
      defaultMessage: 'page',
    }),
    subtitleOne: intl.formatMessage({
      description: 'V2 Success subtitleOne',
      defaultMessage:
        'You can see the summary of all orders placed and download the PDF relating to your purchases on the',
    }),
    subtitleTwo: intl.formatMessage({
      description: 'V2 Success subtitleTwo',
      defaultMessage: 'within your MySalone reserved area.',
    }),
    subtitleLink: intl.formatMessage({
      description: 'V2 Success subtitleLink',
      defaultMessage: 'Order Summary Page',
    }),
    recapTitle: intl.formatMessage({
      description: 'V2 Success recapTitle',
      defaultMessage: 'Order recap',
    }),
  },
  MyTickets: {
    title: intl.formatMessage({
      description: 'V2 My Tickets title',
      defaultMessage: 'My Tickets',
    }),
  },
});

export const getDiscountCodeTranslations = (intl) => ({
  Common: {
    notValidGeneralCode: intl.formatMessage({
      description: 'DiscountCode Common notValidGeneralCode',
      defaultMessage: 'The code you entered is not valid',
    }),
    expiredGeneralCode: intl.formatMessage({
      description: 'DiscountCode Common expiredGeneralCode',
      defaultMessage: 'The code you entered is not valid',
    }),
    specificCode: {
      code: intl.formatMessage({
        description: 'DiscountCode Common specificCode code',
        defaultMessage: 'The code',
      }),
      used: intl.formatMessage({
        description: 'DiscountCode Common specificCode used',
        defaultMessage: 'you entered',
      }),
      notValid: intl.formatMessage({
        description: 'DiscountCode Common specificCode notValid',
        defaultMessage: 'is not valid',
      }),
      expired: intl.formatMessage({
        description: 'DiscountCode Common specificCode expired',
        defaultMessage: 'is not valid',
      }),
    },
    generalCodeError: intl.formatMessage({
      description: 'DiscountCode Common generalCodeError',
      defaultMessage: 'Something went wrong, please try again later.',
    }),
    verifyCodeError: intl.formatMessage({
      description: 'DiscountCode Common verifyCodeError',
      defaultMessage:
        'Something went wrong while verifying your codes, please try again later.',
    }),
    code: intl.formatMessage({
      description: 'DiscountCode Common code',
      defaultMessage: 'Promo code',
    }),
    warning: intl.formatMessage({
      description: 'DiscountCode Common warning',
      defaultMessage: 'Attention',
    }),
  },
  Buy: {
    buttons: {
      apply: intl.formatMessage({
        description: 'Buy buttons apply',
        defaultMessage: 'Apply',
      }),
      add: intl.formatMessage({
        description: 'Buy buttons add',
        defaultMessage: 'Add ticket',
      }),
    },
    appliedCodes: intl.formatMessage({
      description: 'Buy apipliedCodes',
      defaultMessage: 'Promo codes applied',
    }),
    addCodePlaceholder: intl.formatMessage({
      description: 'Buy addCodePlaceholder',
      defaultMessage: 'Enter the promo code',
    }),
    addCodeSub: intl.formatMessage({
      description: 'Buy addCodeSub',
      defaultMessage:
        'Enter the promo code you received when purchasing the Watches and Wonders ticket',
    }),
    greyBox: {
      title: intl.formatMessage({
        description: 'Buy greyBox title',
        defaultMessage:
          'You have purchased a ticket for “Watches and Wonders Geneva 2025”',
      }),
      subtitle: intl.formatMessage({
        description: 'Buy greyBox subtitle',
        defaultMessage:
          'If you have purchased a ticket for Watches and Wonders Geneva, you can use the promo code you received to purchase a ticket for the Salone del Mobile.Milano at a reduced price.',
      }),
      action: intl.formatMessage({
        description: 'Buy greyBox action',
        defaultMessage: 'Buy the Season Promo Ticket',
      }),
    },
  },
});
